import { isRegistered, ReportError, useAuth, useQuery } from '@furality/frontend-stack';
import fox from '#/api/fox.ts';

import QUERY_KEYS from '../QUERY_KEYS.ts';

const useProfileQuery = (requireRegistered = true) => {
  const auth = useAuth();

  return useQuery({
    queryKey: [QUERY_KEYS.Profile, requireRegistered],
    queryFn: async () => {
      const response = await fox.value.userGetProfile();
      switch (response.status) {
        case 200: {
          return response.data;
        }
        default:
          throw new ReportError(response);
      }
    },
    enabled:
      auth.state === 'loggedIn' && (requireRegistered ? isRegistered(auth).registered : true),
  });
};

export default useProfileQuery;
